//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "HubspotForm",
  props: {
    block: {
      type: Object,
      required: true,
    },
    isHidden: {
      type: Boolean,
      default: false,
    },
  },
  // data() {
  //   return {
  //     showHubspotForm: false,
  //   };
  // },
  // Uncomment the following lines if you want to use Vuex for state management for the Hubspot policy acceptance
  // computed: {
  //   acceptedHubspotPolicy() {
  //     return this.$store.state.acceptedHubspotPolicy;
  //   },
  // },
  // watch: {
  //   acceptedHubspotPolicy(val) {
  //     if (val) {
  //       console.log("acceptedHubspotPolicy changed to true, loading form");
  //       this.loadHubspotForm();
  //       console.log(
  //         "setAcceptedHubspotPolicy",
  //         this.$store.state.acceptedHubspotPolicy
  //       );
  //     }
  //   },
  // },
  mounted() {
    const wrapper = this.$refs.hubspotWrapper;
    if (!wrapper) return;

    const script = document.createElement("script");
    script.src = this.block.script_src;
    script.defer = true;

    const placeholder = document.createElement("div");
    placeholder.className = "hs-form-frame";
    placeholder.dataset.region = this.block.region;
    placeholder.dataset.formId = this.block.form_id;
    placeholder.dataset.portalId = this.block.portal_id;

    wrapper.appendChild(script);
    wrapper.appendChild(placeholder);
  },
  // methods: {
  //   loadHubspotForm() {
  //     this.showHubspotForm = true;

  //     this.$nextTick(() => {
  //       const wrapper = this.$refs.hubspotWrapper;
  //       if (!wrapper) return;

  //       const script = document.createElement("script");
  //       script.src = this.block.script_src;
  //       script.defer = true;

  //       const placeholder = document.createElement("div");
  //       placeholder.className = "hs-form-frame";
  //       placeholder.dataset.region = this.block.region;
  //       placeholder.dataset.formId = this.block.form_id;
  //       placeholder.dataset.portalId = this.block.portal_id;

  //       wrapper.appendChild(script);
  //       wrapper.appendChild(placeholder);
  //     });
  //   },
  //   onConsentClick() {
  //     this.$store.commit("setAcceptedHubspotPolicy", true);
  //   },
  // },
};
